{
  "level": "tri01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:tri01",
    "objects": "AREAS.E3:tri01.e3",
    "mesh": "TREES.E3:tri01.e3"
  },
  "spawn_point": {
    "position": [
      1338.9113424862132,
      1434.7616368910847,
      104.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1338.9113424862132,
      1534.7616368910847,
      104.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1168.66796875,
      867.8525390625,
      80.0
    ],
    "bbox_max": [
      1520.0,
      1560.5,
      629.3965454101562
    ],
    "vertex_count": 255,
    "vertices": [
      [
        1188.39990234375,
        867.8525390625,
        170.0
      ],
      [
        1183.5999755859375,
        867.8525390625,
        290.0
      ],
      [
        1187.0400390625,
        1030.0,
        204.0
      ],
      [
        1192.0,
        1030.0,
        80.0
      ],
      [
        1200.0,
        1110.0,
        130.0
      ],
      [
        1196.800048828125,
        867.8525390625,
        170.0
      ],
      [
        1187.199951171875,
        867.8525390625,
        290.0
      ],
      [
        1189.3616943359375,
        1030.0,
        145.95755004882812
      ],
      [
        1200.0,
        1030.0,
        80.0
      ],
      [
        1200.0,
        1030.0,
        129.9989013671875
      ],
      [
        1194.0799560546875,
        1030.0,
        204.0
      ],
      [
        1200.0,
        1030.0,
        204.0
      ],
      [
        1169.9998779296875,
        1120.0,
        130.0
      ],
      [
        1168.66796875,
        1120.0,
        96.70189666748047
      ],
      [
        1395.0,
        1110.0,
        140.0
      ],
      [
        1395.0,
        980.0,
        140.0
      ],
      [
        1490.0,
        1390.0,
        140.0
      ],
      [
        1395.0,
        1295.0,
        140.0
      ],
      [
        1395.0,
        1335.0,
        140.0
      ],
      [
        1450.0,
        1390.0,
        140.0
      ],
      [
        1395.0,
        1170.0,
        140.0
      ],
      [
        1395.0,
        1265.0,
        140.0
      ],
      [
        1520.0,
        1390.0,
        140.0
      ],
      [
        1395.0,
        1265.0,
        140.0
      ],
      [
        1395.0,
        1265.0,
        108.2608642578125
      ],
      [
        1520.0,
        1390.0,
        119.13043212890625
      ],
      [
        1450.0,
        1390.0,
        140.0
      ],
      [
        1395.0,
        1335.0,
        140.0
      ],
      [
        1395.0,
        1335.0,
        138.0
      ],
      [
        1450.0,
        1390.0,
        138.0
      ],
      [
        1520.0,
        1390.0,
        140.0
      ],
      [
        1520.0,
        1390.0,
        290.0
      ],
      [
        1350.0,
        1390.0,
        190.0
      ],
      [
        1350.0,
        1390.0,
        140.0
      ],
      [
        1350.0,
        1390.0,
        579.8990478515625
      ],
      [
        1350.0,
        1390.0,
        490.0
      ],
      [
        1350.0,
        1390.0,
        490.0
      ],
      [
        1350.0,
        1390.0,
        190.0
      ],
      [
        1350.0,
        1220.0,
        140.0
      ],
      [
        1350.0,
        1244.14208984375,
        140.0
      ],
      [
        1350.0,
        1250.0,
        140.0
      ],
      [
        1350.0,
        1290.0,
        140.0
      ],
      [
        1350.0,
        1170.0,
        140.0
      ],
      [
        1350.0,
        1220.0,
        140.0
      ],
      [
        1350.0,
        1220.0,
        140.0
      ],
      [
        1350.0,
        1220.0,
        104.34782409667969
      ],
      [
        1350.0,
        1120.0,
        120.0
      ],
      [
        1350.0,
        1120.0,
        140.0
      ],
      [
        1350.0,
        1290.0,
        140.0
      ],
      [
        1350.0,
        1290.0,
        138.0
      ],
      [
        1350.0,
        1244.14208984375,
        140.0
      ],
      [
        1350.0,
        1244.14208984375,
        138.0
      ],
      [
        1350.0,
        1130.0,
        250.10211181640625
      ],
      [
        1350.0,
        1050.0,
        330.10211181640625
      ],
      [
        1350.0,
        1130.0,
        250.10211181640625
      ],
      [
        1350.0,
        1130.0,
        160.0
      ],
      [
        1350.0,
        1120.0,
        140.0
      ],
      [
        1350.0,
        1130.0,
        160.0
      ],
      [
        1250.0,
        1390.0,
        140.0
      ],
      [
        1250.0,
        1390.0,
        140.0
      ],
      [
        1350.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1030.0,
        140.0
      ],
      [
        1258.0,
        1030.0,
        140.0
      ],
      [
        1350.0,
        1460.0,
        140.0
      ],
      [
        1350.0,
        1460.0,
        153.5
      ],
      [
        1350.0,
        1460.0,
        629.3965454101562
      ],
      [
        1350.0,
        1460.0,
        490.0
      ],
      [
        1350.0,
        1460.0,
        490.0
      ],
      [
        1402.0,
        1484.0,
        160.0
      ],
      [
        1470.0,
        1484.0,
        160.0
      ],
      [
        1470.0,
        1540.0,
        160.0
      ],
      [
        1402.0,
        1540.0,
        160.0
      ],
      [
        1470.0,
        1484.0,
        160.0
      ],
      [
        1470.0,
        1540.0,
        160.0
      ],
      [
        1402.0,
        1505.0,
        160.0
      ],
      [
        1402.0,
        1520.0,
        160.0
      ],
      [
        1402.0,
        1540.0,
        160.0
      ],
      [
        1402.0,
        1520.0,
        160.0
      ],
      [
        1402.0,
        1505.0,
        160.0
      ],
      [
        1402.0,
        1484.0,
        160.0
      ],
      [
        1470.0,
        1522.857177734375,
        210.0
      ],
      [
        1475.0,
        1522.857177734375,
        210.0
      ],
      [
        1475.0,
        1522.857177734375,
        210.0
      ],
      [
        1470.0,
        1522.857177734375,
        210.0
      ],
      [
        1432.0,
        1514.0,
        212.0
      ],
      [
        1432.0,
        1509.0,
        212.0
      ],
      [
        1475.0,
        1540.0,
        206.1290283203125
      ],
      [
        1470.0,
        1540.0,
        206.1290283203125
      ],
      [
        1470.0,
        1540.0,
        206.1290283203125
      ],
      [
        1470.0,
        1540.0,
        210.0
      ],
      [
        1475.0,
        1540.0,
        210.0
      ],
      [
        1475.0,
        1540.0,
        206.1290283203125
      ],
      [
        1410.0,
        1550.0,
        190.0
      ],
      [
        1410.0,
        1545.0,
        190.0
      ],
      [
        1350.0,
        1550.0,
        188.0
      ],
      [
        1350.0,
        1487.0,
        188.0
      ],
      [
        1350.0,
        1490.0,
        188.0
      ],
      [
        1350.0,
        1507.0,
        188.0
      ],
      [
        1350.0,
        1510.0,
        188.0
      ],
      [
        1350.0,
        1527.0,
        188.0
      ],
      [
        1350.0,
        1530.0,
        188.0
      ],
      [
        1350.0,
        1547.0,
        188.0
      ],
      [
        1350.0,
        1550.0,
        188.0
      ],
      [
        1372.0,
        1510.0,
        188.0
      ],
      [
        1375.0,
        1510.0,
        188.0
      ],
      [
        1375.0,
        1510.0,
        190.0
      ],
      [
        1372.0,
        1510.0,
        190.0
      ],
      [
        1372.0,
        1490.0,
        188.0
      ],
      [
        1375.0,
        1490.0,
        188.0
      ],
      [
        1375.0,
        1490.0,
        190.0
      ],
      [
        1372.0,
        1490.0,
        190.0
      ],
      [
        1372.0,
        1487.0,
        190.0
      ],
      [
        1375.0,
        1487.0,
        190.0
      ],
      [
        1375.0,
        1487.0,
        188.0
      ],
      [
        1372.0,
        1487.0,
        188.0
      ],
      [
        1372.0,
        1507.0,
        190.0
      ],
      [
        1375.0,
        1507.0,
        190.0
      ],
      [
        1375.0,
        1507.0,
        188.0
      ],
      [
        1372.0,
        1507.0,
        188.0
      ],
      [
        1372.0,
        1530.0,
        188.0
      ],
      [
        1375.0,
        1530.0,
        188.0
      ],
      [
        1375.0,
        1530.0,
        190.0
      ],
      [
        1372.0,
        1530.0,
        190.0
      ],
      [
        1372.0,
        1527.0,
        190.0
      ],
      [
        1375.0,
        1527.0,
        190.0
      ],
      [
        1375.0,
        1527.0,
        188.0
      ],
      [
        1372.0,
        1527.0,
        188.0
      ],
      [
        1372.0,
        1547.0,
        190.0
      ],
      [
        1375.0,
        1547.0,
        190.0
      ],
      [
        1375.0,
        1547.0,
        188.0
      ],
      [
        1372.0,
        1547.0,
        188.0
      ],
      [
        1350.0,
        1510.0,
        188.0
      ],
      [
        1350.0,
        1490.0,
        188.0
      ],
      [
        1350.0,
        1487.0,
        188.0
      ],
      [
        1350.0,
        1507.0,
        188.0
      ],
      [
        1350.0,
        1530.0,
        188.0
      ],
      [
        1350.0,
        1527.0,
        188.0
      ],
      [
        1350.0,
        1547.0,
        188.0
      ],
      [
        1353.0,
        1471.0,
        161.0
      ],
      [
        1353.0,
        1510.0,
        161.0
      ],
      [
        1350.0,
        1510.0,
        161.0
      ],
      [
        1353.0,
        1510.0,
        161.0
      ],
      [
        1350.0,
        1471.0,
        161.0
      ],
      [
        1353.0,
        1471.0,
        161.0
      ],
      [
        1353.0,
        1510.8038330078125,
        161.0
      ],
      [
        1353.0,
        1510.8038330078125,
        160.00039672851562
      ],
      [
        1373.25,
        1478.75,
        161.0
      ],
      [
        1380.75,
        1493.75,
        161.0
      ],
      [
        1365.75,
        1493.75,
        161.0
      ],
      [
        1373.25,
        1478.75,
        161.0
      ],
      [
        1380.75,
        1493.75,
        161.0
      ],
      [
        1365.75,
        1493.75,
        161.0
      ],
      [
        1351.0,
        1510.0,
        165.0
      ],
      [
        1351.0,
        1510.0,
        161.0
      ],
      [
        1351.0,
        1471.0,
        165.0
      ],
      [
        1351.0,
        1471.0,
        161.0
      ],
      [
        1290.0,
        1460.0,
        190.0
      ],
      [
        1350.0,
        1460.0,
        190.0
      ],
      [
        1288.4000244140625,
        1487.0,
        188.0
      ],
      [
        1252.5596923828125,
        1487.0,
        140.0
      ],
      [
        1263.017333984375,
        1487.0,
        153.0924530029297
      ],
      [
        1306.4453125,
        1490.0,
        160.0
      ],
      [
        1318.3218994140625,
        1490.0,
        160.0
      ],
      [
        1318.3218994140625,
        1490.0,
        161.0
      ],
      [
        1306.4453125,
        1490.0,
        161.0
      ],
      [
        1334.4334716796875,
        1471.0,
        161.0
      ],
      [
        1350.0,
        1471.0,
        161.0
      ],
      [
        1308.826904296875,
        1460.0,
        161.0
      ],
      [
        1304.4334716796875,
        1471.0,
        161.0
      ],
      [
        1304.4334716796875,
        1471.0,
        161.0
      ],
      [
        1308.826904296875,
        1481.76123046875,
        161.0
      ],
      [
        1330.0400390625,
        1481.76123046875,
        161.0
      ],
      [
        1334.4334716796875,
        1471.0,
        161.0
      ],
      [
        1319.4334716796875,
        1486.1546630859375,
        161.0
      ],
      [
        1330.0400390625,
        1481.76123046875,
        161.0
      ],
      [
        1318.3218994140625,
        1490.0,
        161.0
      ],
      [
        1318.3218994140625,
        1490.0,
        160.0
      ],
      [
        1319.4334716796875,
        1486.1546630859375,
        161.0
      ],
      [
        1308.826904296875,
        1481.76123046875,
        161.0
      ],
      [
        1306.4453125,
        1490.0,
        160.0
      ],
      [
        1306.4453125,
        1490.0,
        161.0
      ],
      [
        1318.3218994140625,
        1490.0,
        161.0
      ],
      [
        1318.3218994140625,
        1490.0,
        165.0
      ],
      [
        1318.3218994140625,
        1490.0,
        165.0
      ],
      [
        1306.4453125,
        1490.0,
        161.0
      ],
      [
        1306.4453125,
        1490.0,
        165.0
      ],
      [
        1306.4453125,
        1490.0,
        165.0
      ],
      [
        1260.5472412109375,
        1487.0,
        150.0
      ],
      [
        1262.5440673828125,
        1487.0,
        152.5
      ],
      [
        1263.333251953125,
        1487.0,
        152.5
      ],
      [
        1264.6666259765625,
        1487.0,
        150.0
      ],
      [
        1264.6666259765625,
        1487.0,
        150.0
      ],
      [
        1263.333251953125,
        1487.0,
        152.5
      ],
      [
        1263.333251953125,
        1490.0,
        152.5
      ],
      [
        1264.6666259765625,
        1490.0,
        150.0
      ],
      [
        1294.92822265625,
        1478.0,
        140.0
      ],
      [
        1293.5621337890625,
        1478.0,
        144.0
      ],
      [
        1296.0,
        1476.92822265625,
        140.0
      ],
      [
        1296.0,
        1475.5621337890625,
        144.0
      ],
      [
        1288.4000244140625,
        1510.0,
        188.0
      ],
      [
        1288.4000244140625,
        1507.0,
        188.0
      ],
      [
        1288.4000244140625,
        1527.0,
        188.0
      ],
      [
        1252.5596923828125,
        1510.0,
        140.0
      ],
      [
        1263.017333984375,
        1510.0,
        153.0924530029297
      ],
      [
        1252.5596923828125,
        1507.0,
        140.0
      ],
      [
        1263.017333984375,
        1507.0,
        153.0924530029297
      ],
      [
        1252.5596923828125,
        1527.0,
        140.0
      ],
      [
        1263.017333984375,
        1527.0,
        153.0924530029297
      ],
      [
        1290.0,
        1530.0,
        160.0
      ],
      [
        1320.0,
        1530.0,
        160.0
      ],
      [
        1320.0,
        1530.0,
        161.0
      ],
      [
        1290.0,
        1530.0,
        161.0
      ],
      [
        1350.0,
        1510.0,
        161.0
      ],
      [
        1320.0,
        1510.0,
        161.0
      ],
      [
        1290.0,
        1510.0,
        161.0
      ],
      [
        1290.0,
        1530.0,
        160.0
      ],
      [
        1290.0,
        1530.0,
        161.0
      ],
      [
        1305.0,
        1495.0,
        161.0
      ],
      [
        1294.3934326171875,
        1499.3934326171875,
        161.0
      ],
      [
        1320.0,
        1510.0,
        161.0
      ],
      [
        1315.6065673828125,
        1499.3934326171875,
        161.0
      ],
      [
        1294.3934326171875,
        1499.3934326171875,
        161.0
      ],
      [
        1290.0,
        1510.0,
        161.0
      ],
      [
        1315.6065673828125,
        1499.3934326171875,
        161.0
      ],
      [
        1318.3218994140625,
        1490.0,
        161.0
      ],
      [
        1306.4453125,
        1490.0,
        161.0
      ],
      [
        1305.0,
        1495.0,
        161.0
      ],
      [
        1290.0,
        1530.0,
        165.0
      ],
      [
        1290.0,
        1530.0,
        161.0
      ],
      [
        1290.0,
        1530.0,
        165.0
      ],
      [
        1288.4000244140625,
        1547.0,
        188.0
      ],
      [
        1288.4000244140625,
        1550.0,
        188.0
      ],
      [
        1252.5596923828125,
        1547.0,
        140.0
      ],
      [
        1263.017333984375,
        1547.0,
        153.0924530029297
      ],
      [
        1252.5596923828125,
        1550.0,
        140.0
      ],
      [
        1263.017333984375,
        1550.0,
        153.0924530029297
      ],
      [
        1335.0,
        1560.5,
        140.71295166015625
      ],
      [
        1334.0,
        1560.5,
        140.71295166015625
      ],
      [
        1326.0,
        1560.5,
        140.71295166015625
      ],
      [
        1325.0,
        1560.5,
        140.71295166015625
      ],
      [
        1341.0,
        1560.5,
        140.71295166015625
      ],
      [
        1340.0,
        1560.5,
        140.71295166015625
      ],
      [
        1350.0,
        1560.5,
        140.71295166015625
      ],
      [
        1349.0,
        1560.5,
        140.71295166015625
      ],
      [
        1320.0,
        1545.0,
        161.0
      ],
      [
        1290.0,
        1530.0,
        161.0
      ],
      [
        1290.0,
        1545.0,
        161.0
      ],
      [
        1290.0,
        1545.0,
        161.0
      ],
      [
        1294.3934326171875,
        1555.6065673828125,
        161.0
      ],
      [
        1294.3934326171875,
        1555.6065673828125,
        161.0
      ],
      [
        1305.0,
        1560.0,
        161.0
      ],
      [
        1315.6065673828125,
        1555.6065673828125,
        161.0
      ],
      [
        1320.0,
        1545.0,
        161.0
      ],
      [
        1315.6065673828125,
        1555.6065673828125,
        161.0
      ],
      [
        1305.0,
        1560.0,
        161.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        2400.0,
        1570.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2850.0,
        80.0
      ],
      "bbox_max": [
        2400.0,
        1570.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2500.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1600.0,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1010.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1570.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1010.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1390.0,
        579.8990478515625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1010.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1039.16015625,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1110.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1039.16015625,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1192.0,
        1110.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1039.16015625,
        867.8525390625,
        170.0
      ],
      "bbox_max": [
        1188.39990234375,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1150.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1192.0,
        1110.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1192.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1180.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1110.0,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1183.5999755859375,
        867.8525390625,
        170.0
      ],
      "bbox_max": [
        1196.800048828125,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1187.0400390625,
        960.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1090.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1189.3616943359375,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        145.95755004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1187.0400390625,
        1030.0,
        129.9989013671875
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1187.199951171875,
        867.8525390625,
        129.9989013671875
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1194.0799560546875,
        1030.0,
        129.9989013671875
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1010.0,
        1100.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974521815776825
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1010.0,
        1100.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1168.66796875,
        1120.0,
        96.70189666748047
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1010.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1169.9998779296875,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        1030.0,
        1280.0,
        97.64706420898438
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1299.9998779296875,
      "bbox_min": [
        1180.0,
        1300.0,
        97.64706420898438
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1200.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1390.0,
        579.8990478515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1395.0,
        980.0,
        108.2608642578125
      ],
      "bbox_max": [
        1630.0001220703125,
        1390.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1395.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1395.0,
        1170.0,
        108.2608642578125
      ],
      "bbox_max": [
        1630.0001220703125,
        1390.0,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1395.0,
        1265.0,
        108.2608642578125
      ],
      "bbox_max": [
        1520.0,
        1390.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 42.4263916015625,
      "bbox_min": [
        1395.0,
        1335.0,
        138.0
      ],
      "bbox_max": [
        1450.0,
        1390.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        1400.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1520.0,
        1390.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1200.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1390.0,
        579.8990478515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1350.0,
        980.0,
        104.34782409667969
      ],
      "bbox_max": [
        1395.0,
        1335.0,
        330.10211181640625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1350.0,
        1110.0,
        104.34782409667969
      ],
      "bbox_max": [
        1395.0,
        1335.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1350.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1395.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1380.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1395.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 42.4263916015625,
      "bbox_min": [
        1350.0,
        1232.071044921875,
        138.0
      ],
      "bbox_max": [
        1395.0,
        1335.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1834.335693359375,
      "bbox_min": [
        1350.0,
        1232.071044921875,
        138.0
      ],
      "bbox_max": [
        1362.071044921875,
        1244.14208984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -975.879638671875,
      "bbox_min": [
        1350.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1350.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        250.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1350.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1200.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        1390.0,
        330.10211181640625
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1258.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -701.69580078125,
      "bbox_min": [
        1200.0,
        1055.0,
        118.0
      ],
      "bbox_max": [
        1210.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1210.0,
        1055.0,
        118.0
      ],
      "bbox_max": [
        1210.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1240.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1290.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -711.0697021484375,
      "bbox_min": [
        1310.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071054577827454,
        0.7071080803871155,
        0.0
      ],
      "plane_d": 42.423095703125,
      "bbox_min": [
        1240.0,
        1170.0,
        138.0
      ],
      "bbox_max": [
        1350.0,
        1290.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1300.0,
        1170.0,
        138.0
      ],
      "bbox_max": [
        1350.0,
        1247.071044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1834.335693359375,
      "bbox_min": [
        1347.071044921875,
        1244.14208984375,
        138.0
      ],
      "bbox_max": [
        1350.0,
        1247.071044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1834.3355712890625,
      "bbox_min": [
        1240.0,
        1267.071044921875,
        138.0
      ],
      "bbox_max": [
        1327.071044921875,
        1282.071044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1240.0,
        1270.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -975.879638671875,
      "bbox_min": [
        1200.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1200.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        250.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1200.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1258.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1570.0,
        780.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1075.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1475.0,
        1570.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1075.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        1175.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1475.0,
        1570.0,
        693.0361938476562
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1350.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        217.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1350.0,
        1484.0,
        140.0
      ],
      "bbox_max": [
        1470.0,
        1542.5,
        160.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1484.0,
      "bbox_min": [
        1350.0,
        1484.0,
        140.0
      ],
      "bbox_max": [
        1470.0,
        1540.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1540.0,
      "bbox_min": [
        1350.0,
        1484.0,
        140.0
      ],
      "bbox_max": [
        1470.0,
        1540.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1350.0,
        1484.0,
        140.0
      ],
      "bbox_max": [
        1470.0,
        1540.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1402.0,
      "bbox_min": [
        1350.0,
        1484.0,
        140.0
      ],
      "bbox_max": [
        1440.0,
        1540.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 153.5,
      "bbox_min": [
        1350.0,
        1490.0,
        140.0
      ],
      "bbox_max": [
        1402.0,
        1535.0,
        153.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1505.0,
      "bbox_min": [
        1350.0,
        1490.0,
        140.0
      ],
      "bbox_max": [
        1402.0,
        1535.0,
        153.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9061831831932068,
        0.4228855073451996,
        -0.0
      ],
      "plane_d": -1877.91357421875,
      "bbox_min": [
        1370.0,
        1490.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1505.0,
        153.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1377.0,
        1490.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1505.0,
        153.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1377.0,
        1490.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1490.0,
        153.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        1350.0,
        1520.0,
        140.0
      ],
      "bbox_max": [
        1402.0,
        1535.0,
        153.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9061831831932068,
        -0.4228855073451996,
        0.0
      ],
      "plane_d": -598.6849975585938,
      "bbox_min": [
        1370.0,
        1520.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1535.0,
        153.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1377.0,
        1520.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1535.0,
        153.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1377.0,
        1535.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1535.0,
        153.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1516.330078125,
      "bbox_min": [
        1430.0,
        1507.669921875,
        140.0
      ],
      "bbox_max": [
        1440.0,
        1516.330078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.669921875,
      "bbox_min": [
        1430.0,
        1507.669921875,
        140.0
      ],
      "bbox_max": [
        1440.0,
        1516.330078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -2003.07958984375,
      "bbox_min": [
        1430.0,
        1507.669921875,
        140.0
      ],
      "bbox_max": [
        1440.0,
        1516.330078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 482.40655517578125,
      "bbox_min": [
        1430.0,
        1507.669921875,
        140.0
      ],
      "bbox_max": [
        1440.0,
        1516.330078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": 1994.419189453125,
      "bbox_min": [
        1430.0,
        1507.669921875,
        140.0
      ],
      "bbox_max": [
        1440.0,
        1512.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -491.06671142578125,
      "bbox_min": [
        1437.5,
        1507.669921875,
        140.0
      ],
      "bbox_max": [
        1440.0,
        1512.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        1350.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        217.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        1432.0,
        1509.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1545.0,
        217.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.2202608734369278,
        -0.975441038608551
      ],
      "plane_d": 545.1456298828125,
      "bbox_min": [
        1470.0,
        1514.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1545.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1469.9998779296875,
      "bbox_min": [
        1470.0,
        1514.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1545.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1470.0,
        1514.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1545.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2202608734369278,
        0.975441038608551
      ],
      "plane_d": -540.2684326171875,
      "bbox_min": [
        1470.0,
        1514.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1522.857177734375,
        212.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 217.0,
      "bbox_min": [
        1432.0,
        1509.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1514.0,
        217.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1509.0,
      "bbox_min": [
        1432.0,
        1509.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1514.0,
        217.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -212.0,
      "bbox_min": [
        1432.0,
        1509.0,
        210.0
      ],
      "bbox_max": [
        1475.0,
        1514.0,
        217.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1437.0,
      "bbox_min": [
        1432.0,
        1509.0,
        210.0
      ],
      "bbox_max": [
        1437.0,
        1514.0,
        212.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1432.0,
      "bbox_min": [
        1432.0,
        1509.0,
        210.0
      ],
      "bbox_max": [
        1432.0,
        1514.0,
        212.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1432.0,
      "bbox_min": [
        1432.0,
        1509.0,
        212.0
      ],
      "bbox_max": [
        1475.0,
        1514.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1475.0,
        1509.0,
        212.0
      ],
      "bbox_max": [
        1475.0,
        1514.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1350.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1484.0,
      "bbox_min": [
        1400.0,
        1484.0,
        160.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1540.0,
      "bbox_min": [
        1400.0,
        1484.0,
        160.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1545.0,
      "bbox_min": [
        1400.0,
        1540.0,
        190.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.2202608734369278,
        0.975441038608551
      ],
      "plane_d": -540.2684326171875,
      "bbox_min": [
        1470.0,
        1540.0,
        205.0
      ],
      "bbox_max": [
        1475.0,
        1545.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1469.9998779296875,
      "bbox_min": [
        1470.0,
        1540.0,
        205.0
      ],
      "bbox_max": [
        1475.0,
        1545.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1475.0,
        1540.0,
        205.0
      ],
      "bbox_max": [
        1475.0,
        1545.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1400.0,
        1545.0,
        190.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.0,
        0.8944272994995117
      ],
      "plane_d": 465.1022033691406,
      "bbox_min": [
        1400.0,
        1545.0,
        190.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        1450.0,
        1545.0,
        205.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1475.0,
        1545.0,
        205.0
      ],
      "bbox_max": [
        1475.0,
        1550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        0.0,
        -0.8944272994995117
      ],
      "plane_d": -460.63006591796875,
      "bbox_min": [
        1400.0,
        1545.0,
        190.0
      ],
      "bbox_max": [
        1450.0,
        1550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1400.0,
        1545.0,
        190.0
      ],
      "bbox_max": [
        1420.0,
        1550.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1400.0,
        1545.0,
        190.0
      ],
      "bbox_max": [
        1410.0,
        1550.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1410.0,
        1545.0,
        190.0
      ],
      "bbox_max": [
        1420.0,
        1550.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1402.0,
        1484.0,
        160.0
      ],
      "bbox_max": [
        1475.0,
        1540.0,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1475.0,
        1522.857177734375,
        206.1290283203125
      ],
      "bbox_max": [
        1475.0,
        1540.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": 1020.6483154296875,
      "bbox_min": [
        1402.0,
        1484.0,
        160.0
      ],
      "bbox_max": [
        1470.0,
        1540.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -656.7650756835938,
      "bbox_min": [
        1402.0,
        1484.0,
        160.0
      ],
      "bbox_max": [
        1470.0,
        1540.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.0,
        -0.8320502638816833
      ],
      "plane_d": 981.8193359375,
      "bbox_min": [
        1402.0,
        1484.0,
        160.0
      ],
      "bbox_max": [
        1470.0,
        1540.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1402.0,
      "bbox_min": [
        1402.0,
        1484.0,
        160.0
      ],
      "bbox_max": [
        1417.0,
        1540.0,
        210.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": -611.2796630859375,
      "bbox_min": [
        1402.0,
        1484.0,
        200.0
      ],
      "bbox_max": [
        1417.0,
        1540.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000000715255737,
        0.0,
        -0.6000000238418579
      ],
      "plane_d": -966.0001220703125,
      "bbox_min": [
        1350.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1400.0,
        1550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1350.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1400.0,
        1550.0,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 188.0,
      "bbox_min": [
        1350.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1400.0,
        1550.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1350.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1550.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        1350.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1372.0,
      "bbox_min": [
        1350.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1372.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1372.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1507.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1487.0,
      "bbox_min": [
        1372.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1487.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.0,
      "bbox_min": [
        1372.0,
        1507.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1507.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1530.0,
      "bbox_min": [
        1372.0,
        1527.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        1372.0,
        1527.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1527.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        1372.0,
        1547.0,
        188.0
      ],
      "bbox_max": [
        1375.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1350.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1372.0,
        1507.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1487.0,
      "bbox_min": [
        1350.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1372.0,
        1487.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.0,
      "bbox_min": [
        1350.0,
        1507.0,
        188.0
      ],
      "bbox_max": [
        1372.0,
        1507.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1530.0,
      "bbox_min": [
        1350.0,
        1527.0,
        188.0
      ],
      "bbox_max": [
        1372.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        1350.0,
        1527.0,
        188.0
      ],
      "bbox_max": [
        1372.0,
        1527.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        1350.0,
        1547.0,
        188.0
      ],
      "bbox_max": [
        1372.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1375.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1375.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1507.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1487.0,
      "bbox_min": [
        1375.0,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1487.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.0,
      "bbox_min": [
        1375.0,
        1507.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1507.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1530.0,
      "bbox_min": [
        1375.0,
        1527.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        1375.0,
        1527.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1527.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        1375.0,
        1547.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1547.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -161.0,
      "bbox_min": [
        1350.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1390.0,
        1550.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1353.0,
      "bbox_min": [
        1350.0,
        1471.0,
        160.0
      ],
      "bbox_max": [
        1390.0,
        1550.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1350.0,
        1471.0,
        160.0
      ],
      "bbox_max": [
        1353.0,
        1510.8038330078125,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1471.0,
      "bbox_min": [
        1350.0,
        1471.0,
        160.0
      ],
      "bbox_max": [
        1353.0,
        1471.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882017612457275,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1109.1402587890625,
      "bbox_min": [
        1350.0,
        1510.0,
        160.0
      ],
      "bbox_max": [
        1353.0,
        1510.8038330078125,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 102.784423828125,
      "bbox_min": [
        1353.0,
        1478.75,
        160.0
      ],
      "bbox_max": [
        1390.0,
        1550.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255146980286,
        -0.25882017612457275,
        0.0
      ],
      "plane_d": -941.4652099609375,
      "bbox_min": [
        1353.0,
        1510.8038330078125,
        160.00039672851562
      ],
      "bbox_max": [
        1390.0,
        1550.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882017612457275,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1109.1402587890625,
      "bbox_min": [
        1353.0,
        1510.8038330078125,
        160.00039672851562
      ],
      "bbox_max": [
        1370.0,
        1515.3590087890625,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -566.955078125,
      "bbox_min": [
        1365.75,
        1478.75,
        160.0
      ],
      "bbox_max": [
        1380.75,
        1493.75,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": 1889.5894775390625,
      "bbox_min": [
        1365.75,
        1478.75,
        160.0
      ],
      "bbox_max": [
        1380.75,
        1493.75,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1493.75,
      "bbox_min": [
        1365.75,
        1493.75,
        160.0
      ],
      "bbox_max": [
        1380.75,
        1493.75,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1353.0,
      "bbox_min": [
        1350.0,
        1460.0,
        161.0
      ],
      "bbox_max": [
        1380.75,
        1550.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        1350.0,
        1471.0,
        161.0
      ],
      "bbox_max": [
        1353.0,
        1550.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1351.0,
      "bbox_min": [
        1350.0,
        1471.0,
        161.0
      ],
      "bbox_max": [
        1353.0,
        1550.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1350.0,
        1471.0,
        161.0
      ],
      "bbox_max": [
        1351.0,
        1529.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1471.0,
      "bbox_min": [
        1350.0,
        1471.0,
        161.0
      ],
      "bbox_max": [
        1351.0,
        1471.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1529.0,
      "bbox_min": [
        1350.0,
        1529.0,
        161.0
      ],
      "bbox_max": [
        1351.0,
        1529.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1471.0,
      "bbox_min": [
        1351.0,
        1471.0,
        161.0
      ],
      "bbox_max": [
        1353.0,
        1510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1351.0,
        1510.0,
        161.0
      ],
      "bbox_max": [
        1353.0,
        1510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -566.955078125,
      "bbox_min": [
        1365.75,
        1460.0,
        161.0
      ],
      "bbox_max": [
        1380.75,
        1493.75,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": 1889.5894775390625,
      "bbox_min": [
        1365.75,
        1478.75,
        161.0
      ],
      "bbox_max": [
        1380.75,
        1493.75,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1493.75,
      "bbox_min": [
        1365.75,
        1478.75,
        161.0
      ],
      "bbox_max": [
        1380.75,
        1493.75,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        1365.75,
        1478.75,
        175.0
      ],
      "bbox_max": [
        1380.75,
        1493.75,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        1368.5,
        1460.0,
        182.0
      ],
      "bbox_max": [
        1378.5,
        1465.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        1368.5,
        1460.0,
        182.0
      ],
      "bbox_max": [
        1378.5,
        1465.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1465.0,
      "bbox_min": [
        1368.5,
        1460.0,
        182.0
      ],
      "bbox_max": [
        1378.5,
        1465.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1368.5,
      "bbox_min": [
        1368.5,
        1460.0,
        182.0
      ],
      "bbox_max": [
        1378.5,
        1465.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1378.5,
      "bbox_min": [
        1378.5,
        1460.0,
        182.0
      ],
      "bbox_max": [
        1378.5,
        1465.0,
        184.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688879013062,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": -888.6287841796875,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1530.0,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        190.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1487.0,
      "bbox_min": [
        1288.4000244140625,
        1487.0,
        188.0
      ],
      "bbox_max": [
        1350.0,
        1487.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1490.0,
        188.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1487.0,
      "bbox_min": [
        1250.0,
        1487.0,
        140.0
      ],
      "bbox_max": [
        1290.9000244140625,
        1487.0,
        188.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1252.5596923828125,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1490.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -161.0,
      "bbox_min": [
        1304.4334716796875,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1490.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1471.0,
      "bbox_min": [
        1304.4334716796875,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1490.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9286678433418274,
        -0.37091267108917236,
        -0.0
      ],
      "plane_d": 1756.9979248046875,
      "bbox_min": [
        1304.4334716796875,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1308.826904296875,
        1471.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9258148074150085,
        0.3779776990413666,
        0.0
      ],
      "plane_d": 651.6586303710938,
      "bbox_min": [
        1304.4334716796875,
        1471.0,
        160.0
      ],
      "bbox_max": [
        1334.4334716796875,
        1490.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9258148074150085,
        0.3779776990413666,
        -0.0
      ],
      "plane_d": -1791.443359375,
      "bbox_min": [
        1318.3218994140625,
        1471.0,
        160.0
      ],
      "bbox_max": [
        1334.4334716796875,
        1490.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": -1877.955810546875,
      "bbox_min": [
        1318.3218994140625,
        1481.76123046875,
        160.0
      ],
      "bbox_max": [
        1330.0400390625,
        1490.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606683254241943,
        0.27769845724105835,
        0.0
      ],
      "plane_d": -1680.2408447265625,
      "bbox_min": [
        1318.3218994140625,
        1486.1546630859375,
        160.0
      ],
      "bbox_max": [
        1319.4334716796875,
        1490.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9606683254241943,
        -0.27769845724105835,
        -0.0
      ],
      "plane_d": 1668.831298828125,
      "bbox_min": [
        1306.4453125,
        1481.76123046875,
        160.0
      ],
      "bbox_max": [
        1308.826904296875,
        1490.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1471.0,
      "bbox_min": [
        1304.4334716796875,
        1460.0,
        161.0
      ],
      "bbox_max": [
        1350.0,
        1490.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9258148074150085,
        0.3779776990413666,
        0.0
      ],
      "plane_d": 651.6586303710938,
      "bbox_min": [
        1304.4334716796875,
        1471.0,
        161.0
      ],
      "bbox_max": [
        1334.4334716796875,
        1490.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9258148074150085,
        0.3779776990413666,
        -0.0
      ],
      "plane_d": -1791.443359375,
      "bbox_min": [
        1318.3218994140625,
        1471.0,
        161.0
      ],
      "bbox_max": [
        1334.4334716796875,
        1490.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": -1877.955810546875,
      "bbox_min": [
        1318.3218994140625,
        1481.76123046875,
        161.0
      ],
      "bbox_max": [
        1330.0400390625,
        1490.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9606683254241943,
        0.27769845724105835,
        0.0
      ],
      "plane_d": -1680.2408447265625,
      "bbox_min": [
        1318.3218994140625,
        1486.1546630859375,
        161.0
      ],
      "bbox_max": [
        1319.4334716796875,
        1490.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9606683254241943,
        -0.27769845724105835,
        -0.0
      ],
      "plane_d": 1668.831298828125,
      "bbox_min": [
        1306.4453125,
        1481.76123046875,
        161.0
      ],
      "bbox_max": [
        1308.826904296875,
        1490.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9286678433418274,
        -0.37091267108917236,
        -0.0
      ],
      "plane_d": 1756.9979248046875,
      "bbox_min": [
        1304.4334716796875,
        1460.0,
        161.0
      ],
      "bbox_max": [
        1308.826904296875,
        1471.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        1252.5596923828125,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1490.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -152.5,
      "bbox_min": [
        1260.5472412109375,
        1460.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1490.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1275.0,
      "bbox_min": [
        1260.5472412109375,
        1460.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1490.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1479.0,
      "bbox_min": [
        1275.0,
        1460.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1479.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1297.0,
      "bbox_min": [
        1290.0,
        1460.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1479.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659227728843689,
        0.25883039832115173,
        0.0
      ],
      "plane_d": -1633.80029296875,
      "bbox_min": [
        1290.0,
        1472.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1479.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883039832115173,
        0.9659227728843689,
        0.0
      ],
      "plane_d": -1762.490966796875,
      "bbox_min": [
        1290.0,
        1475.5,
        150.0
      ],
      "bbox_max": [
        1296.0621337890625,
        1479.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1959.79052734375,
      "bbox_min": [
        1293.5,
        1475.5,
        150.0
      ],
      "bbox_max": [
        1296.0621337890625,
        1478.0621337890625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1486.9998779296875,
      "bbox_min": [
        1260.5472412109375,
        1487.0,
        150.0
      ],
      "bbox_max": [
        1264.6666259765625,
        1490.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1263.333251953125,
        1487.0,
        150.0
      ],
      "bbox_max": [
        1264.6666259765625,
        1490.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1262.5440673828125,
        1487.0,
        152.5
      ],
      "bbox_max": [
        1263.333251953125,
        1490.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1486.9998779296875,
      "bbox_min": [
        1262.5440673828125,
        1487.0,
        152.5
      ],
      "bbox_max": [
        1263.333251953125,
        1487.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1486.9998779296875,
      "bbox_min": [
        1252.5596923828125,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1490.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1264.6666259765625,
        1487.0,
        140.0
      ],
      "bbox_max": [
        1270.0,
        1490.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        1275.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1480.0,
        150.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": -1469.765869140625,
      "bbox_min": [
        1275.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1480.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1478.0,
      "bbox_min": [
        1275.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1480.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2515832781791687,
        0.9389384984970093,
        0.23473462462425232
      ],
      "plane_d": -1747.0341796875,
      "bbox_min": [
        1275.0,
        1478.0,
        140.0
      ],
      "bbox_max": [
        1294.92822265625,
        1480.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1275.0,
      "bbox_min": [
        1275.0,
        1478.0,
        140.0
      ],
      "bbox_max": [
        1294.92822265625,
        1480.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6873481273651123,
        0.6873481273651123,
        0.23474466800689697
      ],
      "plane_d": -1938.831298828125,
      "bbox_min": [
        1293.5,
        1478.0,
        140.0
      ],
      "bbox_max": [
        1294.92822265625,
        1478.92822265625,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        -0.0,
        0.24253563582897186
      ],
      "plane_d": -1293.199951171875,
      "bbox_min": [
        1290.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1296.0,
      "bbox_min": [
        1290.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9389353394508362,
        0.25158241391181946,
        0.23474816977977753
      ],
      "plane_d": -1621.93212890625,
      "bbox_min": [
        1296.0,
        1472.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1476.92822265625,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6873481273651123,
        0.6873481273651123,
        0.23474466800689697
      ],
      "plane_d": -1938.831298828125,
      "bbox_min": [
        1296.0,
        1475.5,
        140.0
      ],
      "bbox_max": [
        1296.92822265625,
        1476.92822265625,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1958.824462890625,
      "bbox_min": [
        1290.0,
        1472.0,
        140.0
      ],
      "bbox_max": [
        1296.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6873481273651123,
        0.6873481273651123,
        0.23474466800689697
      ],
      "plane_d": -1938.831298828125,
      "bbox_min": [
        1293.5621337890625,
        1475.5621337890625,
        140.0
      ],
      "bbox_max": [
        1296.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965927004814148,
        -0.2588146924972534,
        -0.0
      ],
      "plane_d": 1632.816650390625,
      "bbox_min": [
        1290.0,
        1472.0,
        140.0
      ],
      "bbox_max": [
        1296.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588146924972534,
        -0.965927004814148,
        -0.0
      ],
      "plane_d": 1761.5111083984375,
      "bbox_min": [
        1290.0,
        1477.1961669921875,
        140.0
      ],
      "bbox_max": [
        1293.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8637789487838745,
        -0.5038710832595825
      ],
      "plane_d": -1188.559814453125,
      "bbox_min": [
        1275.0,
        1460.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1479.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1275.0,
      "bbox_min": [
        1275.0,
        1460.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1463.5,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1277.5999755859375,
      "bbox_min": [
        1277.5999755859375,
        1460.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1463.5,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": 1386.3623046875,
      "bbox_min": [
        1275.0,
        1475.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1479.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1275.0,
      "bbox_min": [
        1275.0,
        1475.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1479.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1277.5999755859375,
      "bbox_min": [
        1275.0,
        1475.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1479.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1479.0,
      "bbox_min": [
        1275.0,
        1479.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1479.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 188.0,
      "bbox_min": [
        1250.0,
        1490.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.0,
      "bbox_min": [
        1288.4000244140625,
        1507.0,
        188.0
      ],
      "bbox_max": [
        1350.0,
        1507.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        1288.4000244140625,
        1527.0,
        188.0
      ],
      "bbox_max": [
        1350.0,
        1527.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1250.0,
        1507.0,
        140.0
      ],
      "bbox_max": [
        1290.9000244140625,
        1527.0,
        188.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.0,
      "bbox_min": [
        1250.0,
        1507.0,
        140.0
      ],
      "bbox_max": [
        1290.9000244140625,
        1507.0,
        188.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        1250.0,
        1527.0,
        140.0
      ],
      "bbox_max": [
        1290.9000244140625,
        1527.0,
        188.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1252.5596923828125,
        1490.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -161.0,
      "bbox_min": [
        1290.0,
        1490.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        1290.0,
        1490.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        1510.0,
        160.0
      ],
      "bbox_max": [
        1290.0,
        1530.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": 1769.6600341796875,
      "bbox_min": [
        1290.0,
        1499.3934326171875,
        160.0
      ],
      "bbox_max": [
        1294.3934326171875,
        1510.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9606683254241943,
        0.27769845724105835,
        0.0
      ],
      "plane_d": -1680.2408447265625,
      "bbox_min": [
        1315.6065673828125,
        1490.0,
        160.0
      ],
      "bbox_max": [
        1318.3218994140625,
        1499.3934326171875,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9606683254241943,
        -0.27769845724105835,
        -0.0
      ],
      "plane_d": 1668.831298828125,
      "bbox_min": [
        1305.0,
        1490.0,
        160.0
      ],
      "bbox_max": [
        1306.4453125,
        1495.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        1290.0,
        1490.0,
        161.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        1510.0,
        161.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1325.0,
      "bbox_min": [
        1324.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1335.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1334.0,
      "bbox_min": [
        1325.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1335.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1526.5999755859375,
      "bbox_min": [
        1334.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1335.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        1334.0,
        1526.5999755859375,
        165.0
      ],
      "bbox_max": [
        1335.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1326.0,
      "bbox_min": [
        1325.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1326.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1526.5999755859375,
      "bbox_min": [
        1325.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1326.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        1325.0,
        1526.5999755859375,
        165.0
      ],
      "bbox_max": [
        1326.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        1324.0,
        1529.0,
        161.0
      ],
      "bbox_max": [
        1325.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1529.0,
      "bbox_min": [
        1324.0,
        1529.0,
        161.0
      ],
      "bbox_max": [
        1325.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        1324.0,
        1529.0,
        165.0
      ],
      "bbox_max": [
        1325.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1341.0,
      "bbox_min": [
        1340.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1340.0,
      "bbox_min": [
        1340.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1341.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1526.5999755859375,
      "bbox_min": [
        1340.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1341.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        1340.0,
        1526.5999755859375,
        165.0
      ],
      "bbox_max": [
        1341.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1349.0,
      "bbox_min": [
        1349.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1526.5999755859375,
      "bbox_min": [
        1349.0,
        1526.5999755859375,
        161.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        1349.0,
        1526.5999755859375,
        165.0
      ],
      "bbox_max": [
        1350.0,
        1530.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": 1880.604248046875,
      "bbox_min": [
        1290.0,
        1490.0,
        161.0
      ],
      "bbox_max": [
        1320.0,
        1510.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -641.6615600585938,
      "bbox_min": [
        1290.0,
        1490.0,
        161.0
      ],
      "bbox_max": [
        1320.0,
        1510.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": 1769.6600341796875,
      "bbox_min": [
        1290.0,
        1499.3934326171875,
        161.0
      ],
      "bbox_max": [
        1294.3934326171875,
        1510.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9606683254241943,
        0.27769845724105835,
        0.0
      ],
      "plane_d": -1680.2408447265625,
      "bbox_min": [
        1315.6065673828125,
        1490.0,
        161.0
      ],
      "bbox_max": [
        1318.3218994140625,
        1499.3934326171875,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9606683254241943,
        -0.27769845724105835,
        -0.0
      ],
      "plane_d": 1668.831298828125,
      "bbox_min": [
        1305.0,
        1490.0,
        161.0
      ],
      "bbox_max": [
        1306.4453125,
        1495.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1526.9998779296875,
      "bbox_min": [
        1252.5596923828125,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1530.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1263.017333984375,
        1527.0,
        140.0
      ],
      "bbox_max": [
        1270.0,
        1530.0,
        153.09242248535156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1252.5596923828125,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1506.9998779296875,
      "bbox_min": [
        1252.5596923828125,
        1507.0,
        140.0
      ],
      "bbox_max": [
        1270.0,
        1510.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1252.5596923828125,
        1510.0,
        140.0
      ],
      "bbox_max": [
        1270.0,
        1510.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -142.99998474121094,
      "bbox_min": [
        1299.4774169921875,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        160.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.3090081810951233,
        0.9510594606399536,
        0.0
      ],
      "plane_d": -1033.265869140625,
      "bbox_min": [
        1299.4774169921875,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090081810951233,
        -0.9510594606399536,
        -0.0
      ],
      "plane_d": 1829.423095703125,
      "bbox_min": [
        1299.4774169921875,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1299.4774169921875,
      "bbox_min": [
        1299.4774169921875,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.809033989906311,
        0.5877618789672852,
        0.0
      ],
      "plane_d": -1944.989013671875,
      "bbox_min": [
        1306.4185791015625,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.809033989906311,
        -0.5877618789672852,
        0.0
      ],
      "plane_d": -175.8258056640625,
      "bbox_min": [
        1306.4185791015625,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1505.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090165853500366,
        0.951056718826294,
        0.0
      ],
      "plane_d": -1030.250732421875,
      "bbox_min": [
        1302.4774169921875,
        1502.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1507.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090165853500366,
        -0.951056718826294,
        -0.0
      ],
      "plane_d": 1832.429931640625,
      "bbox_min": [
        1302.4774169921875,
        1502.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1507.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1302.4774169921875,
      "bbox_min": [
        1302.4774169921875,
        1502.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1507.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8090288043022156,
        0.587769091129303,
        0.0
      ],
      "plane_d": -1941.9931640625,
      "bbox_min": [
        1305.2725830078125,
        1502.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1507.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8090288043022156,
        -0.587769091129303,
        0.0
      ],
      "plane_d": -172.8082275390625,
      "bbox_min": [
        1305.2725830078125,
        1502.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1505.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 188.0,
      "bbox_min": [
        1250.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        1288.4000244140625,
        1547.0,
        188.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1288.4000244140625,
        1550.0,
        188.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1250.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        188.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        1250.0,
        1547.0,
        140.0
      ],
      "bbox_max": [
        1290.9000244140625,
        1550.0,
        188.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1290.9000244140625,
        1550.0,
        188.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1325.0,
      "bbox_min": [
        1252.5596923828125,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.6139406561851501,
        -0.7893522381782532
      ],
      "plane_d": 1066.4149169921875,
      "bbox_min": [
        1325.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        165.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1335.0,
      "bbox_min": [
        1325.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1334.0,
      "bbox_min": [
        1325.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1335.0,
        1560.5,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.6229267716407776,
        0.7822801470756531
      ],
      "plane_d": -1082.1541748046875,
      "bbox_min": [
        1334.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1335.0,
        1560.5,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1334.0,
        1560.5,
        140.0
      ],
      "bbox_max": [
        1335.0,
        1560.5,
        140.71295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.5,
      "bbox_min": [
        1334.0,
        1557.0,
        140.71295166015625
      ],
      "bbox_max": [
        1335.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1334.0,
        1560.5,
        140.71295166015625
      ],
      "bbox_max": [
        1335.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1326.0,
      "bbox_min": [
        1325.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1326.0,
        1560.5,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.6229267716407776,
        0.7822801470756531
      ],
      "plane_d": -1082.1541748046875,
      "bbox_min": [
        1325.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1326.0,
        1560.5,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1325.0,
        1560.5,
        140.0
      ],
      "bbox_max": [
        1326.0,
        1560.5,
        140.71295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.5,
      "bbox_min": [
        1325.0,
        1557.0,
        140.71295166015625
      ],
      "bbox_max": [
        1326.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1325.0,
        1560.5,
        140.71295166015625
      ],
      "bbox_max": [
        1326.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1341.0,
      "bbox_min": [
        1340.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1340.0,
      "bbox_min": [
        1340.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1341.0,
        1560.5,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.6229267716407776,
        0.7822801470756531
      ],
      "plane_d": -1082.1541748046875,
      "bbox_min": [
        1340.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1341.0,
        1560.5,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1340.0,
        1560.5,
        140.0
      ],
      "bbox_max": [
        1341.0,
        1560.5,
        140.71295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.5,
      "bbox_min": [
        1340.0,
        1557.0,
        140.71295166015625
      ],
      "bbox_max": [
        1341.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1340.0,
        1560.5,
        140.71295166015625
      ],
      "bbox_max": [
        1341.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1349.0,
      "bbox_min": [
        1349.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.6229267716407776,
        0.7822801470756531
      ],
      "plane_d": -1082.1541748046875,
      "bbox_min": [
        1349.0,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1349.0,
        1560.5,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        140.71295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.5,
      "bbox_min": [
        1349.0,
        1557.0,
        140.71295166015625
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1560.5,
      "bbox_min": [
        1349.0,
        1560.5,
        140.71295166015625
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        1252.5596923828125,
        1530.0,
        140.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -160.99998474121094,
      "bbox_min": [
        1290.0,
        1530.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        1290.0,
        1530.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": -941.8431396484375,
      "bbox_min": [
        1294.3934326171875,
        1545.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": -1810.7703857421875,
      "bbox_min": [
        1305.0,
        1545.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        -0.0
      ],
      "plane_d": -1940.6563720703125,
      "bbox_min": [
        1305.0,
        1555.6065673828125,
        160.0
      ],
      "bbox_max": [
        1315.6065673828125,
        1560.0,
        161.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        1290.0,
        1530.0,
        161.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        1530.0,
        161.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 600.5512084960938,
      "bbox_min": [
        1290.0,
        1545.0,
        161.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": -941.8431396484375,
      "bbox_min": [
        1294.3934326171875,
        1545.0,
        161.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": -1810.7703857421875,
      "bbox_min": [
        1305.0,
        1545.0,
        161.0
      ],
      "bbox_max": [
        1320.0,
        1560.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": 1940.6563720703125,
      "bbox_min": [
        1305.0,
        1555.6065673828125,
        161.0
      ],
      "bbox_max": [
        1315.6065673828125,
        1560.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1252.5596923828125,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1555.9044189453125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1546.9998779296875,
      "bbox_min": [
        1252.5596923828125,
        1547.0,
        140.0
      ],
      "bbox_max": [
        1270.0,
        1550.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1549.9998779296875,
      "bbox_min": [
        1252.5596923828125,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1270.0,
        1550.0,
        153.0924530029297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.0,
      "bbox_min": [
        1299.4774169921875,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1555.9044189453125,
        160.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3090081810951233,
        -0.9510594606399536,
        -0.0
      ],
      "plane_d": 1872.2208251953125,
      "bbox_min": [
        1299.4774169921875,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1555.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090081810951233,
        0.9510594606399536,
        0.0
      ],
      "plane_d": -1076.0635986328125,
      "bbox_min": [
        1299.4774169921875,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1555.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1299.4774169921875,
      "bbox_min": [
        1299.4774169921875,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1555.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.809033989906311,
        0.5877618789672852,
        0.0
      ],
      "plane_d": -1971.4383544921875,
      "bbox_min": [
        1306.4185791015625,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1555.9044189453125,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.809033989906311,
        -0.5877618789672852,
        0.0
      ],
      "plane_d": -149.37646484375,
      "bbox_min": [
        1306.4185791015625,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1550.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090165853500366,
        -0.951056718826294,
        0.0
      ],
      "plane_d": 1875.2275390625,
      "bbox_min": [
        1302.4774169921875,
        1547.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1552.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090165853500366,
        0.951056718826294,
        0.0
      ],
      "plane_d": -1073.04833984375,
      "bbox_min": [
        1302.4774169921875,
        1547.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1552.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1302.4774169921875,
      "bbox_min": [
        1302.4774169921875,
        1547.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1552.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8090288043022156,
        -0.587769091129303,
        0.0
      ],
      "plane_d": -146.3585205078125,
      "bbox_min": [
        1305.2725830078125,
        1547.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1552.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8090288043022156,
        0.587769091129303,
        -0.0
      ],
      "plane_d": -1968.44287109375,
      "bbox_min": [
        1305.2725830078125,
        1550.0,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1552.377685546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1090.0,
        1390.0,
        105.0
      ],
      "bbox_max": [
        1530.0,
        1460.0,
        629.3965454101562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1129.9998779296875,
      "bbox_min": [
        1090.0,
        1390.0,
        105.0
      ],
      "bbox_max": [
        1160.0,
        1430.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1090.0,
        1390.0,
        105.0
      ],
      "bbox_max": [
        1130.0,
        1430.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913018971681595,
        0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": -1419.4140625,
      "bbox_min": [
        1090.0,
        1415.0,
        105.0
      ],
      "bbox_max": [
        1110.0,
        1430.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.2559814453125,
      "bbox_min": [
        1090.0,
        1420.0,
        125.0
      ],
      "bbox_max": [
        1110.0,
        1430.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.2559814453125,
      "bbox_min": [
        1110.0,
        1395.0,
        113.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1430.0,
        136.42857360839844
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.06912980228662491,
        0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": -1419.4136962890625,
      "bbox_min": [
        1120.0,
        1415.0,
        113.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1420.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1130.0,
        1395.0,
        119.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1430.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.25601196289062,
      "bbox_min": [
        1130.0,
        1395.0,
        136.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1420.0,
        139.2857208251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747208774089813,
        0.0,
        -0.9615241289138794
      ],
      "plane_d": -179.2552032470703,
      "bbox_min": [
        1130.0,
        1420.0,
        136.42857360839844
      ],
      "bbox_max": [
        1160.0,
        1430.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1180.0,
        1390.0,
        119.13043212890625
      ],
      "bbox_max": [
        1530.0,
        1460.0,
        629.3965454101562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        1450.0,
        1390.0,
        119.13043212890625
      ],
      "bbox_max": [
        1530.0,
        1419.7767333984375,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1450.0,
        1390.0,
        138.0
      ],
      "bbox_max": [
        1499.7767333984375,
        1419.7767333984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 42.4263916015625,
      "bbox_min": [
        1450.0,
        1390.0,
        138.0
      ],
      "bbox_max": [
        1479.7767333984375,
        1419.7767333984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1180.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1180.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1215.0,
      "bbox_min": [
        1215.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1215.0,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1250.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1290.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071045637130737,
        0.0,
        -0.7071089744567871
      ],
      "plane_d": 1051.69189453125,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071045637130737,
        0.0,
        -0.7071089744567871
      ],
      "plane_d": -815.064208984375,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588188052177429,
        0.0,
        -0.965925931930542
      ],
      "plane_d": -187.09268188476562,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188052177429,
        0.0,
        -0.965925931930542
      ],
      "plane_d": 496.18896484375,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965927004814148,
        0.0,
        -0.25881466269493103
      ],
      "plane_d": 1330.576171875,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.0,
        -0.25881466269493103
      ],
      "plane_d": -1219.4710693359375,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1302.679443359375,
        1460.0,
        150.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}